import BaseHttpService from "JS/services/BaseHttpService";
import CarouselTrackingService from "JS/services/CarouselTrackingService";
import { AddToCartResult, AddToCartSuccessResponse, IMilwaukeeAddToCartResponse, IPDPAddToCartResponse } from "JS/services/ProductService";
import { getPriceMode } from 'JS/types/Product';
import { IBaseHttpService } from "JS/types/Http";
import { IQuickCartSummaryJson } from 'JS/types/Order';

const BASE_URL = '/milwaukee-packout/';

export interface IMilwaukeePackoutBuilderService {
	addToCart(products: { [key: string]: number }): Promise<IPDPAddToCartResponse>;
}

export default class MilwaukeePackoutBuilderService implements IMilwaukeePackoutBuilderService {
	constructor(private _httpService: IBaseHttpService = new BaseHttpService()) {}

	async addToCart(products: { [key: string]: number }): Promise<IPDPAddToCartResponse> {
		//in future if multiple possible boxes or dynamic boxes, send contents back to server
		const response = await this._httpService.post<IMilwaukeeAddToCartResponse>(
			`${BASE_URL}/add-to-cart/`,
			 { data: products });

		if (response.addToCartResponse.result !== AddToCartResult.Success) {
			return response.addToCartResponse;
		}
		
		const successResult = response.addToCartResponse as AddToCartSuccessResponse;

		if (successResult.cartSummary) {
			this.updateHeader(successResult.cartSummary);
		}
	
		const blainNumbersAdded = 
				successResult.addedProducts.map(product => product.blainNumber);
		const cartProducts = successResult.cartSummary.productsInCart.filter(
			(product) =>  blainNumbersAdded.includes(product.blainNumber)
		);
		
		const orderProducts = successResult.cartSummary.productsInCart.map(item => ({
			blainNumber: item.price.blainNumber,
			qty: item.qty,
			unitPrice: item.price.price,
			vendorBrand: item.vendorBrand,
			productName: item.productName,
			imageUrl: item.imageUrlLarger,
			productUrl: item.virtualURL
		}));

		const carouselTrackingService = new CarouselTrackingService();
		carouselTrackingService.trackViews(
			[{ itemListID: "milwaukee_packout_builder",
				itemListName: "Milwaukee Packout Builder",
				carouselProducts: response.productsAddedAsCarousel
			}]);

		cartProducts.forEach(product => {
			carouselTrackingService.trackClick(null,
				{
					itemListID: "milwaukee_packout_builder",
					itemListName: "Milwaukee Packout Builder",
					currentPrice: product.price.currentPrice,
					blainNumber: product.blainNumber,
					vendorBrand: product.vendorBrand,
					productName: product.productName,
					belowMap: product.price.isBelowMAP,
					priceMode: getPriceMode(product.price),
					index: 0 // Position is not relevant
				}
			);
	
			window.blainGtmDataLayer.push({
				'blainNumber': product.blainNumber,
				'vendorBrand': product.vendorBrand,
				'productName': product.productName,
				'deliveryChannel': "Ship",
				'totalValue': product.unitPrice,
				'qty': product.qty,
				'orderProducts': orderProducts,
				'orderId': successResult.orderID,
				'event': "cart_ajax_add"
			});
		});
	
		return response.addToCartResponse;
	}
	
	updateHeader(cartSummary: IQuickCartSummaryJson ) {
		if (window.vueEventBus && cartSummary) {
			window.vueEventBus.$emit('update-quick-cart', cartSummary);
		}
	}
}
